export default (anamesis) => {
    if (!anamesis.formData) {
        anamesis.formData = {}
    }

    if (!anamesis.formData.teethIndication) {
        anamesis.formData.teethIndication = {}
    }

    if (!anamesis.formData.additionalIndication) {
        anamesis.formData.additionalIndication = null
    }

    if (!anamesis.formData.treatmentExpectation) {
        anamesis.formData.treatmentExpectation = []
    }
    return anamesis
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/initialize-implant-treatment-physician-assesment.js